import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pwa-instructions" }
const _hoisted_2 = { class: "instructions-title" }
const _hoisted_3 = ["src"]

import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import iosPwaEn from '@/assets/app-store/iosPwa_en.png';
import iosPwaPt from '@/assets/app-store/iosPwa.png';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppStorePwaInstructionsPopup',
  setup(__props, { expose: __expose }) {

const { t, locale } = useI18n();
const visible = ref(false);

const instructionImage = computed(() => {
  return locale.value === 'pt' ? iosPwaPt : iosPwaEn;
});

const open = () => {
  visible.value = true;
};

const close = () => {
  visible.value = false;
};

__expose({ open, close });

return (_ctx: any,_cache: any) => {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: visible.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    round: "",
    style: {"width":"85%","background":"transparent"},
    onClickOverlay: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", { class: "instructions-header" }, [
          _createElementVNode("span", {
            class: "close-btn",
            onClick: close
          }, "✕")
        ]),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('download.pwaDownloadInstructions')), 1),
        (_openBlock(), _createElementBlock("img", {
          key: instructionImage.value,
          src: instructionImage.value,
          alt: "",
          class: "instructions-image"
        }, null, 8, _hoisted_3))
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})